export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=d7e8a890&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/list.vue?vue&type=template&id=d7e8a890&
// module id = 1158
// module chunks = 0